import { ICache } from '../models/cache';
import { ICacheClearArgs } from '../models/cache-clear-args';
import { ICacheReadArgs } from '../models/cache-read-args';
import { ICacheWriteArgs } from '../models/cache-write-args';
import { SharedCacheBuckets } from '../models/shared-cache-buckets';
import { SharedCacheIds } from '../models/shared-cache-ids';

export class PersistentCache implements ICache {
  constructor(
    private args: {
      memoryCache: ICache;
      dbCache: ICache;
    },
  ) {}

  public async read<T>(args: ICacheReadArgs<T>): Promise<T> {
    return this.args.memoryCache.read({
      ...args,
      retrieve: () => this.args.dbCache.read(args),
    });
  }

  public async write<T>(args: ICacheWriteArgs<T>) {
    await Promise.all([
      this.args.memoryCache.write(args),
      this.args.dbCache.write(args),
    ]);
  }

  public async clear(args?: ICacheClearArgs) {
    await Promise.all([
      this.args.memoryCache.clear(args),
      this.args.dbCache.clear(args),
    ]);
    await this.writeLastClear(args?.bucket || SharedCacheIds.All);
  }

  public async clearByBucket(bucket: string) {
    await Promise.all([
      this.args.memoryCache.clearByBucket(bucket),
      this.args.dbCache.clearByBucket(bucket),
    ]);
    await this.writeLastClear(bucket);
  }

  private writeLastClear(bucket: string) {
    return this.args.dbCache.write({
      bucket: SharedCacheBuckets.LastMemoryCacheClear,
      id: bucket,
      value: Date.now(),
      refreshAfterMilliseconds: 0,
    });
  }
}
